<script>
import required from "vuelidate/lib/validators/required";
import DatePicker from "vue2-datepicker";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";

export default {
  name: "DisposalModal",
  components: {
    DatePicker,
    MaskedInput
  },
  data() {
    return {
      submitted: false,
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true
      }),
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false
      }),
      tableData: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        {
          key: "id",
          sortable: true,
          label: "Disposal",
          thStyle: { width: "85%" },
        },
      ],
      form: {
        id: "",
        description: "",
        venue: "",
        disposalMethod: "",
        destination: "",
        orNumber: "",
        orDate: "",
        amount: "",
        inspectedBy: "",
        witness: "",
        notes: "",
        campusId: 0
      },
      indexSelected: -1,
      tableBusy: false,
      multiple: false,
    };
  },
  validations: {
    form: {
      description: { required }
    }
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (
            item.description.toUpperCase().includes(this.filter.toUpperCase())
          )
            return item.description
              .toUpperCase()
              .includes(this.filter.toUpperCase());
        });
      }
      return data;
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    },
  },
  methods: {
    getData() {
      this.tableBusy = true;
      this.$store
        .dispatch(
          "propertydisposal/GetPropertyDisposal",
          this.$store.state.data.selectedCampus.id
        )
        .then((res) => {
          this.tableBusy = false;
          this.tableData = res.data;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting draft disposal list!",
            "error"
          );
        });
    },
    onCreate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.form.campusId = this.$store.state.data.selectedCampus.id;
        this.form.amount = this.form.amount != "" && this.form.amount != null ? this.getExactAmt(this.form.amount) : "0";
        this.form.orDate = this.form.orDate != "" && this.form.orDate != null ? this.getDate(this.form.orDate) : "0001-01-01T00:00:00";
        this.$store
          .dispatch("propertydisposal/CreatePropertyDisposal", this.form)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.onReset();
            this.$bvModal.hide("modal-create-disposal");
            this.showToast("Successfully created!", "success");
            this.onRowSelected([res.data]);
          })
          .catch((err) => {
            this.showToast(
              "Something went wrong - creating disposal!",
              "error"
            );
          });
      }
      this.submitted = false;
    },
    createDisposal() {
      this.onReset();
      this.modalTitle = "Create Disposal";
      this.$bvModal.show("modal-create-disposal");
    },
    onReset() {
      this.form = {
        id: "",
        description: "",
        venue: "",
        disposalMethod: "",
        destination: "",
        orNumber: "",
        orDate: "",
        amount: "",
        inspectedBy: "",
        witness: "",
        notes: "",
        campusId: ""
      };
      this.submitted = false;
    },
    onRowSelected(data) {
      this.$emit("dropData", data[0]);
      this.$bvModal.hide("disposal-modal");
    },
  },
};
</script>

<template>
  <div>
    <!-- Create Disposal -->
    <b-modal id="modal-create-disposal" :title="modalTitle" size="md" title-class="font-18" hide-footer
      no-close-on-backdrop>
      <form @submit.prevent="onCreate" class="needs-validation" ref="fcForm">
        <div class="mb-3">
          <label for="description">Description </label>
          <input id="description" type="text" v-model="form.description" placeholder="Enter Description..."
            class="form-control" :class="{
              'is-invalid': submitted && $v.form.description.$error
            }" autocomplete="off" />
          <div v-if="submitted && $v.form.description.$error" class="invalid-feedback">
            <span v-if="!$v.form.description.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="venue">Venue </label>
          <input id="venue" type="text" v-model="form.venue" placeholder="Enter Venue..." class="form-control"
            autocomplete="off" />
        </div>
        <div class="mb-3">
          <label for="inspectedBy">Inspected By </label>
          <input id="inspectedBy" type="text" v-model="form.inspectedBy" placeholder="Enter Inspector's Name..." class="form-control"
            autocomplete="off" />
        </div>
        <div class="mb-3">
          <label for="witness">Witness </label>
          <input id="witness" type="text" v-model="form.witness" placeholder="Enter Witness..." class="form-control"
            autocomplete="off" />
        </div>
        <div class="mb-3">
          <label for="orNumber">OR Number </label>
          <input id="orNumber" type="text" v-model="form.orNumber" placeholder="Enter OR Number..." class="form-control"
            autocomplete="off" />
        </div>
        <div class="mb-3">
          <label for="orDate">OR Date</label>
          <date-picker v-model="form.orDate" :first-day-of-week="1" lang="en"
            placeholder="Enter Start Date..."></date-picker>
        </div>
        <div class="mb-3">
          <label for="amount">Amount </label>
          <masked-input id="amount" type="text" v-model="form.amount" placeholder="Enter Amount..." class="form-control"
            autocomplete="off" :mask="currencyMask"></masked-input>
        </div>
        <div class="mb-3">
          <label for="notes">Notes </label>
          <textarea id="notes" rows="2" v-model="form.notes" placeholder="Enter Notes..." class="form-control"
            autocomplete="off"></textarea>
        </div>
        <div class="d-flex flex-row-reverse">
          <button type="submit" class="btn btn-primary">Create</button>
        </div>
      </form>
    </b-modal>
    <!-- Main -->
    <b-modal id="disposal-modal" title="Draft Disposal List" size="lg" title-class="font-18" hide-footer
      no-close-on-backdrop>
      <div class="row mt-1">
        <div class="col-md-6">
          <div id="tickets-table_filter" class="dataTables_filter">
            <label class="d-inline-flex align-items-center">
              Search:
              <b-form-input autocomplete="off" v-model="filter" type="search" placeholder="Search..."
                class="form-control form-control-sm mx-2 w-75"></b-form-input>
              <b-form-select class="form-select form-select-sm w-25" v-model="perPage"
                :options="pageOptions"></b-form-select>
            </label>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex float-end">
            <button type="button" @click="createDisposal()"
              class="btn btn-sm btn-success d-flex align-items-center ms-1">
              <i class="bx bx-plus fs-6 me-1"></i>Create Disposal
            </button>
          </div>
        </div>
      </div>
      <div class="custom-table-responsive mb-0">
        <b-table class="propertyTable datatables target-table" :items="filtered" :fields="fields" responsive="sm"
          :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
          :busy="tableBusy" bordered outlined hover striped show-empty select-mode="single" selectable
          @row-selected="onRowSelected" selected-variant="success">
          <template #empty>
            <b-card-header>
              <div class="text-center">
                <div v-if="filter != ''">
                  <i class="fas fa-exclamation-triangle me-2"></i>There are no
                  disposals matching your request
                </div>
                <div v-else>
                  <i class="fas fa-exclamation-triangle me-2"></i>No disposals
                  available
                </div>
              </div>
            </b-card-header>
          </template>
          <template #table-busy>
            <b-card-header>
              <div class="d-flex justify-content-center align-items-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-20px h-20px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <strong>Loading...</strong>
              </div>
            </b-card-header>
          </template>
          <template #cell(id)="row">
            <b-card-header header-tag="header" class="border" role="tab">
              <div>
                <b>
                  {{ row.item.description }}
                </b>
                <div class="d-flex align-items-center">
                  {{ formatDate(new Date(row.item.disposalDateTime)) }}
                </div>
              </div>
            </b-card-header>
          </template>
        </b-table>
      </div>
      <div class="row">
        <div v-if="rows > 0" class="col">
          Showing {{ (currentPage - 1) * perPage + 1 }} -
          {{
            rows > (currentPage - 1) * perPage + perPage
              ? (currentPage - 1) * perPage + perPage
              : rows
          }}
          of {{ rows }}
        </div>
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
              <!-- pagination -->
              <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
